import _ from "lodash";
import { Modules } from "src/types/osbuilder";

import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";
import { skipToken } from "@reduxjs/toolkit/query";

import { AndroidModule, Build, Product } from "../types";

import { useFetchProductsQuery } from "./index";

function serializeModule(module: Modules[number]): AndroidModule {
    const tags = ["Added"];

    if ("tags" in module && Array.isArray(module.tags)) {
        tags.push(...(module.tags as string[]));
    }
    return { ...module, name: module.name as string, tags: _.uniq(tags) };
}
function serializeProduct(products: API.Product[]): Product[] {
    return products.map(({ created: _created, numberOfBuilds: _numberOfBuilds, ...rest }) => {
        const response = { ...rest };

        if (response.customBuildConfig && !response.customBuildConfig.manifest) {
            response.customBuildConfig.manifest = {};
        }
        if (response.customBuildConfig && response.customBuildConfig.manifest && !response.customBuildConfig.manifest.projects) {
            response.customBuildConfig.manifest.projects = [];
        }
        if (response.customBuildConfig && !response.customBuildConfig.sources) {
            response.customBuildConfig.sources = {};
        }
        if (response.customBuildConfig && !response.customBuildConfig.modules) {
            response.customBuildConfig.modules = [];
        }
        if (response.customBuildConfig && !response.customBuildConfig.buildVariant) {
            response.customBuildConfig.buildVariant = "user";
        }
        if (response.customBuildConfig && response.customBuildConfig.modules) {
            response.customBuildConfig.modules = response.customBuildConfig.modules.map(serializeModule);
        }

        return response as Product;
    });
}

function serializeBuild(build: API.Build): Build {
    return {
        ...build,
        artifacts: (build.artifacts ?? []).map((item) => ({
            ...item,
            link: "",
        })),
    };
}

type FetchProductsQueryOptions = Omit<Parameters<typeof useFetchProductsQuery>[1], "selectFromResult">;

function useCurrentWorkspaceProducts(options?: FetchProductsQueryOptions) {
    const { data: workspace } = useCurrentWorkspace();
    const isTerminated = workspace?.subscription?.status === "Terminated";

    const arg = workspace?.id ? { workspaceId: workspace.id, isTerminated } : skipToken;

    return useFetchProductsQuery(arg, options);
}

export { serializeBuild, serializeProduct, useCurrentWorkspaceProducts };
